import { SVGProps } from 'react'

export const Photo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20" {...props}>
    <path
      fill="currentColor"
      d="M18 2.5H3c-.833 0-1.667.833-1.667 1.667v11.666c0 .917.75 1.667 1.667 1.667h15c.833 0 1.667-.833 1.667-1.667V4.167c0-.834-.834-1.667-1.667-1.667zM4.667 14.167l2.916-3.75 2.084 2.508 2.916-3.758 3.75 5H4.667z"
    ></path>
  </svg>
)
